<script setup>
// The kit's rule card speaking the Guardrails and Guidelines pages' language (phase 4.4): a rule is a string at an
// index of the assistant's list; the card edits it in place (Enter saves, Escape leaves) and the events go back as
// the pages already know them: edit({ id, content }), delete(id), select(id).
import RuleCard from 'dashboard/components-next/polaris/cards/RuleCard.vue';

const props = defineProps({
  rule: { type: Object, required: true }, // { id, content }
  selectable: { type: Boolean, default: false },
  selected: { type: Boolean, default: false },
});

const emit = defineEmits(['edit', 'delete', 'select']);
</script>

<template>
  <RuleCard
    :content="rule.content"
    :selectable="selectable"
    :selected="selected"
    @edit="content => emit('edit', { id: props.rule.id, content })"
    @delete="emit('delete', props.rule.id)"
    @select="emit('select', props.rule.id)"
  />
</template>
